import IconButtonsTypes from '~/constants/types/IconButtonsTypes';
import {createAction} from 'redux-actions';

export const activateIntersectingIconButton = createAction(
  IconButtonsTypes.ACTIVATE_INTERSECTING_ICON
);
export const deactivateIntersectingIconButton = createAction(
  IconButtonsTypes.DEACTIVATE_INTERSECTING_ICON
);
